import placesListModule from '../placesListModule';

function playerInteractionController(
  $scope,
  $log,
  resources,
  eventStreamService,
  modalData,
  $uibModalInstance,
  playGameService
) {
  'ngInject';

  $scope.sendEventStream = function(eventType, properties) {
    if (!properties) {
      properties = {};
    }
    eventStreamService.sendEventWithTarget(eventType.name, eventType.ctx, properties);
  };

  $scope.sendGamePlayEvent = function(rootPlaceId) {
    eventStreamService.sendGamePlayEvent(
      resources.eventStreamParams.gamePlayIntentInPlacesList.ctx,
      rootPlaceId
    );
  };

  $scope.joinGame = function(playerId) {
    const { presence } = $scope.library.peopleLibrary[playerId];
    const { rootPlaceId } = presence;
    const { placeId } = presence;
    const gameInstanceId = presence.gameId;
    const propertiesForEvent = {
      rootPlaceId,
      placeId
    };

    const playGameProperties = playGameService.buildPlayGameProperties(
      rootPlaceId,
      placeId,
      gameInstanceId,
      playerId
    );
    const eventStreamProperties = {
      eventName: resources.eventStreamParams.joinGameInPlacesList.name,
      ctx: resources.eventStreamParams.joinGameInPlacesList.ctx,
      properties: propertiesForEvent,
      gamePlayIntentEventCtx: resources.eventStreamParams.gamePlayIntentInPlacesList.ctx
    };
    playGameService.launchGame(playGameProperties, eventStreamProperties);
    $uibModalInstance.dismiss();
  };

  $scope.openModal = function() {
    const { placeId } = $scope.game;
    const propertiesForEvent = {
      placeId
    };
    $scope.sendEventStream(resources.eventStreamParams.openModalFromGameTile, propertiesForEvent);
  };

  $scope.library = modalData.library;
  $scope.game = modalData.game;
  $scope.layout = modalData.layout;
  $scope.openModal();
}

placesListModule.controller('playerInteractionController', playerInteractionController);

export default playerInteractionController;
